import { useQueryClient } from '@tanstack/react-query';
import { useEffect, useRef } from 'react';
import { useAuth } from './AuthContext';

/**
 * Clears the React Query cache whenever the active organization switches to a
 * different non-null organization. PersistQueryClientProvider persists the
 * cache, so without this a stale organization's data could be served — and
 * re-persisted — for another organization (cross-org cache leakage). The reset
 * is intentionally skipped on the initial null -> org hydration so freshly
 * persisted cache is not wiped on every app start.
 */
export function OrgCacheReset(): null {
  const { currentOrganization } = useAuth();
  const queryClient = useQueryClient();
  const prevOrgId = useRef<string | null>(null);

  const orgId = currentOrganization?.id ?? null;

  useEffect(() => {
    if (prevOrgId.current !== null && orgId !== null && prevOrgId.current !== orgId) {
      queryClient.clear();
    }
    prevOrgId.current = orgId;
  }, [orgId, queryClient]);

  return null;
}

export default OrgCacheReset;
